<template>
  <div
    class="confirm-pin md:tw-w-[610px] tw-w-11/12 tw-flex tw-items-center tw-pb-8 tw-rounded-[10px] md:tw-h-[532px]"
  >
    <div class="tw-max-w-[365px] tw-mx-auto">
      <OnboardingHeader headerText="Confirm your PIN" />
      <!-- <OnboardingSubHeader subHeaderText="Confirm your 4-digit pin." /> -->
      <ConfirmPinForm class="tw-w-full tw-mt-8" />
      <span
        class="tw-block tw-mx-auto tw-text-primary tw-mt-8 tw-cursor-pointer tw-text-center tw-w-[80px]"
        @click="$router.go(-1)"
        >Restart</span
      >
    </div>
  </div>
</template>

<script>
  import OnboardingHeader from "@/components/onboarding/OnboardingHeader";
  // import OnboardingSubHeader from "@/components/onboarding/OnboardingSubHeader";
  import ConfirmPinForm from "@/components/onboarding/forms/ConfirmPinForm";
  import { getItem } from "@/utils/storage.js";

  export default {
    name: "ConfirmPin",

    components: {
      OnboardingHeader,
      // OnboardingSubHeader,
      ConfirmPinForm,
    },
    created() {
      const id = getItem("org_details")?._id;
      if (!id) {
        this.$router.push({ name: "SignIn" });
      }
    },
  };
</script>

<style lang="scss" scoped>
  .confirm-pin {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  }
</style>
